import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { maskMap } from '@defi/core-utils';

var InputMasked =
/*#__PURE__*/
function (_Component) {
  _inherits(InputMasked, _Component);

  function InputMasked(props) {
    var _this;

    _classCallCheck(this, InputMasked);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputMasked).call(this, props));

    _this.handleChange = function (e) {
      var curPos = e.target.selectionEnd;

      var normalizedValue = _this.normalize(e.target.value); // for when extra character is added like , in Money curPos needs to be moved up


      if (normalizedValue.length > e.target.value.length) {
        curPos += normalizedValue.length - e.target.value.length;
      }

      _this.setState({
        currentValue: normalizedValue
      });

      e.preventDefault();

      _this.setState({
        curPos: curPos
      }, function () {
        _this.props.onChange(normalizedValue);
      });
    };

    _this.normalize = function (value) {
      if (_this.props.mask.hasMask) {
        if (_this.props.mask.editMask) {
          return maskMap.getMaskedValue(value, _this.props.mask.editMask, true);
        } else {
          return maskMap.getMaskedValue(value, _this.props.mask.readEditMask, true);
        }
      } else {
        return value;
      }
    };

    _this.state = {
      isFocused: false,
      currentValue: props.value,
      curPos: (props.value || '').length
    };
    return _this;
  }

  _createClass(InputMasked, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.refs.textField) {
        this.refs.textField.input.setSelectionRange(this.state.curPos, this.state.curPos);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(TextField, Object.assign({}, this.props, {
        context: "",
        onChange: this.handleChange,
        value: this.state.currentValue,
        multiline: this.props.multiLine ? true : false,
        InputProps: {
          inputProps: {
            maxLength: this.props.maxLength
          }
        },
        "data-testid": "InputMasked"
      }));
    }
  }]);

  return InputMasked;
}(Component);

export default InputMasked;